'use client';

/**
 * useCustomer - Hook to access current customer data (v2)
 */

import { Customer } from '../../../react/types';
import { useTagadaContext } from '../providers/TagadaProvider';

export interface UseCustomerResult {
    customer: Customer | null;
    isAuthenticated: boolean;
    isLoading: boolean;
    isAnonymous: boolean;
}

export function useCustomer(): UseCustomerResult {
    const { customer, isLoading } = useTagadaContext();

    return {
        customer,
        isAuthenticated: customer?.isAuthenticated || false,
        isLoading,
        isAnonymous: customer?.role === 'anonymous',
    };
}

